/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import "../../css/header.scss";

const Header = ({ info }) => (
  <div className="header">
    <div className="logo">
      <a href="https://www.michigandaily.com/" target="_blank" rel="noreferrer">
        <img
          src="https://i0.wp.com/www.michigandaily.com/wp-content/uploads/2021/03/cropped-TMDFullLogo.png?fit=2854%2C388&ssl=1"
          alt="Michigan Daily Logo"
        />
      </a>
    </div>
    <div className="title">
      <h1>{info.title}</h1>
    </div>
  </div>
);

Header.propTypes = {
  info: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default Header;
